import { useCallback } from 'react';
import useWaApi from './axios/useWaApi';
import { User } from '../store/WaUserStore';

export interface WaLoginRequestBody {
  username: string;
  password: string;
}

export interface WaLocationUpdateRequestBody {
  latitude: number;
  longitude: number;
}

function useWaSecurityRepo() {
  const { post, get, patch } = useWaApi();

  const postLoginRequest = useCallback(
    async (body: WaLoginRequestBody) =>
      await post<void>('/api/wa/login', body, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }),
    [post]
  );

  const postLogoutRequest = useCallback(async () => {
    try {
      return await post<void>('/api/wa/logout');
    } catch (error) {
      console.log(error);
      return;
    }
  }, [post]);

  const getUserRequest = useCallback(async () => {
    try {
      return await get<User>(`/api/wa/users/me`);
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [get]);

  const patchUserLocationRequest = useCallback(
    async (body: WaLocationUpdateRequestBody) => {
      try {
        return await patch<User>(`/api/wa/users/me`, body);
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    [patch]
  );

  return {
    postLoginRequest,
    postLogoutRequest,
    getUserRequest,
    patchUserLocationRequest,
  };
}

export default useWaSecurityRepo;
